import { formatQualityScore } from '@/lib/audioQualityScore';
import { Grid, Stack, Text } from '@careflux/primitives';
import { MetricTile } from './MetricTile';
import type { AudioQualityOverviewProps } from './audioQuality.types';
import { EMPTY_VALUE, SUPPRESSED_LABEL, formatNumber, formatPercent } from './formatting';

export const formatAudioQualityScore = (score: number | null) =>
  score == null ? EMPTY_VALUE : formatQualityScore(score);

export const AudioQualityOverview = ({ data }: AudioQualityOverviewProps) => (
  <Stack gap="md">
    <Text size="sm" color="muted">
      {formatNumber(data.assessedRecordings)} metnar af {formatNumber(data.totalRecordings)} skráðum upptökum ·{' '}
      {formatNumber(data.partialRecordings)} með ólokið mat · Útgáfa: {data.scorerVersion ?? 'Engin'}
    </Text>
    <Grid columns={{ base: 1, md: 2, xl: 4 }} gap="md">
      <MetricTile
        title="Áætluð hljóðgæði"
        value={formatAudioQualityScore(data.scoreMean)}
        suppressed={data.suppressed}
        detail="Bráðabirgðamat á skýrleika tals"
      />
      <MetricTile
        title="Viðvarandi slök gæði"
        value={formatNumber(data.poorRecordings)}
        detail={data.suppressed ? SUPPRESSED_LABEL : `${formatPercent(data.poorRate)} af metnum upptökum`}
      />
      <MetricTile
        title="Þekja greiningar"
        value={formatPercent(data.analysisCoverage)}
        detail="Hlutfall glugga sem tókst að greina; ekki hlutfall alls hljóðs í skrá"
      />
      <MetricTile
        title="Ómetnar upptökur"
        value={formatNumber(data.unknownRecordings)}
        detail={`${formatNumber(data.stateCounts.insufficientSpeech)} með ónóg talgögn · ${formatNumber(data.stateCounts.unavailable)} án mats`}
      />
    </Grid>
  </Stack>
);
